
import $ from "jquery"

import StickyNavbarHandler from "app/sticky_navbar_handler/index"


const SELECTOR = ".js-smooth-scrolling-navbar"

const INIT_DONE_CLASS_NAME = "js--js-smooth-scrolling-navbar--init-done"


function initOneElement(link_container: Element): void {
  const $link_container = $(link_container)

  if ($link_container.hasClass(INIT_DONE_CLASS_NAME)) {
    return
  }
  else {
    $link_container.addClass(INIT_DONE_CLASS_NAME)
  }

  $link_container.find("a").each((_idx, link) => {
    const $link = $(link)

    $link.on("click", (e: JQueryEventObject) => {
      const href = $link.attr("href")
      // Prevent non anchor value
      if (!/^#/.test(href)) {
        return
      }
      const $targetElement = $(href)

      // If found
      if ($targetElement.length) {
        StickyNavbarHandler.scrollTo($targetElement)

        // And prevent adding the hash to URL
        e.preventDefault()
        e.stopPropagation()
      }
    })
  })
}

const onLoad = () => {
  // On document ready
  $(SELECTOR).each((_idx, element) => {
    initOneElement(element)
  })

  // On AJAX success
  $(document).ajaxSuccess(() => {
    $(SELECTOR).each((_idx, element) => {
      initOneElement(element)
    })
  })
}


export default {
  onLoad: onLoad,
}
